<template>
    <a-modal :bodyStyle="{ maxHeight: '80vh', overflow: 'auto' }" :centered="true" :title="state.modalTitle"
        :width="1200" :open="open" :confirmLoading="state.confirmLoading" :maskClosable="state.maskClosable"
        @ok="onFormSubmit" @cancel="cancelClick">
        <template #footer>
            <a-button key="取消" @click="cancelClick">取消</a-button>
            <a-button key="确定提交" type="primary" :loading="formState.loading" @click="onFormSubmit">确定提交</a-button>
        </template>
        <a-spin :spinning="state.loading">
            <a-form ref="formRef" :model="formState" :rules="rules" v-bind="formLayout">
                <!-- 基础信息 -->
                <a-form-item label="主体名称" name="full_name">
                    <a-input v-model:value="formState.full_name" @change="uploadPathChange" placeholder="请输入主体名称"
                        @blur="aicheck"></a-input>
                </a-form-item>
                <a-form-item label="统一社会信用代码" name="social_credit_code">
                    <a-input v-model:value="formState.social_credit_code" placeholder="请输入统一社会信用代码"></a-input>
                </a-form-item>
                <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }" label="待注销的主体类型" required>
                    <a-radio-group v-model:value="formState.main_type" button-style="solid"
                        @change="principalTypeChange">
                        <a-radio-button :value="2">个体户</a-radio-button>
                        <a-radio-button :value="1">公司</a-radio-button>
                        <a-radio-button :value="3">个独</a-radio-button>
                        <a-radio-button :value="4">合伙</a-radio-button>
                    </a-radio-group>
                </a-form-item>
                <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }" label="注销类型"
                    v-if="formState.main_type != 2">
                    <a-radio-group v-model:value="formState.logout_type" button-style="solid">
                        <a-radio-button :value="1">简易注销</a-radio-button>
                        <a-radio-button :value="2">一般注销</a-radio-button>
                    </a-radio-group>
                </a-form-item>

                <a-form-item label="注销原因" name="etpsRepeal_rplReasonGb" v-if="formState.main_type != 2" required>
                    <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                        v-model:value="formState.etpsRepeal_rplReasonGb" placeholder="请选择">
                        <a-select-option value="经营期限届满">经营期限届满</a-select-option>
                        <a-select-option value="决议解散">决议解散</a-select-option>
                        <a-select-option value="强制解散">强制解散</a-select-option>
                        <a-select-option value="责令关闭">责令关闭</a-select-option>
                        <a-select-option value="被撤销">被撤销</a-select-option>
                        <a-select-option value="宣告破产">宣告破产</a-select-option>
                        <a-select-option value="被吊销营业执照">被吊销营业执照</a-select-option>
                        <a-select-option value="隶属(派出)企业终止">隶属(派出)企业终止</a-select-option>
                        <a-select-option value="外国（地区）企业 撤销代表机构">外国（地区）企业 撤销代表机构</a-select-option>
                        <a-select-option value="因合并或分立">因合并或分立</a-select-option>
                        <a-select-option value="章程规定的解散事由出现">章程规定的解散事由出现</a-select-option>
                        <a-select-option value="合伙人已不具备法定人数">合伙人已不具备法定人数</a-select-option>
                        <a-select-option value="合伙协议约定的合伙目的已经实现或者无法实现">合伙协议约定的合伙目的已经实现或者无法实现</a-select-option>
                        <a-select-option
                            value="投资人死亡或者被宣告死亡,无继承人或者继承人决定放弃继承">投资人死亡或者被宣告死亡,无继承人或者继承人决定放弃继承</a-select-option>
                        <a-select-option value="合伙协议约定的解散事由出现">合伙协议约定的解散事由出现</a-select-option>
                        <a-select-option value="企业法人歇业">企业法人歇业</a-select-option>
                        <a-select-option value="其他原因">其他原因</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="注销原因" name="etpsRepeal_rplReasonGb" v-if="formState.main_type == 2" required>
                    <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                        v-model:value="formState.etpsRepeal_rplReasonGb" placeholder="请选择">
                        <a-select-option value="停止经营">停止经营</a-select-option>
                        <a-select-option value="依法被吊销营业执照">依法被吊销营业执照</a-select-option>
                        <a-select-option value="依法被撤销设立登记">依法被撤销设立登记</a-select-option>
                        <a-select-option value="个转企">个转企</a-select-option>
                        <a-select-option value="改为公司">改为公司</a-select-option>
                        <a-select-option value="改为个人独资">改为个人独资</a-select-option>
                        <a-select-option value="改为合伙企业">改为合伙企业</a-select-option>
                        <a-select-option value="转让给其他经营者">转让给其他经营者</a-select-option>
                        <a-select-option value="其他">其他</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }" label="注销授权方式" required>
                    <a-radio-group v-model:value="formState.logout_sqtype" button-style="solid">
                        <a-radio-button :value="2">电子营业执照授权</a-radio-button>
                        <a-radio-button :value="1">联络员收验证码</a-radio-button> </a-radio-group><br />
                    <a @click="copyShouquan()">点击复制授权方式</a>
                </a-form-item>
                <a-form-item label="主体所在省市区" name="recipient_area_ids">
                    <AddressCascader v-model:value="formState.recipient_area_ids" @change="recipient_area_ids_change">
                    </AddressCascader>
                </a-form-item>
                <a-form-item label="联络员身份证号码" name="liaison_identity" v-if="formState.logout_sqtype == 1">
                    <a-input v-model:value="formState.liaison_identity" placeholder="请输入联络员身份证号码"></a-input>
                </a-form-item>

                <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }" label="原营业执照提交方式" required>
                    <a-radio-group v-model:value="formState.appFlog_sumType" button-style="solid"
                        @change="yyzzliandong">
                        <a-radio-button :value="3">执照遗失或损坏公告作废</a-radio-button>
                        <a-radio-button :value="1">到登记窗口提交</a-radio-button>
                    </a-radio-group>
                </a-form-item>
                <a-form-item name="business_license_and_copy"
                    v-if="formState.appFlog_sumType == 1 || formState.appFlog_sumType == 3"
                    :label="formState.appFlog_sumType == 3 ? '全国企业网遗失公示截图' : '营业执照正本和副本'" htmlFor="{null}">
                    <Upload :upload_path="formState.upload_path" :accept="['png', 'jpg', 'jpeg', 'pdf']"
                        uploadType="picture-card" :limitation="99" v-model:value="formState.business_license_and_copy"
                        :uploadText="formState.appFlog_sumType == 3 ? '全国企业网遗失公示截图' : '营业执照正本和副本'"
                        :beforeCheck="beforeCheck">
                    </Upload>
                </a-form-item>
                <a-form-item name="isTaxReg" label="是否已办理清税证明" v-if="formState.main_type == 2" required>
                    <a-radio-group v-model:value="formState.isTaxReg" button-style="solid">
                        <a-radio-button :value="0">否（未办理税务登记）</a-radio-button>
                        <a-radio-button :value="1">是（税务已注销）</a-radio-button>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="公告报纸名称" name="etpsRepeal_announcePaper" v-if="formState.main_type != 2">
                    <a-input v-model:value="formState.etpsRepeal_announcePaper" placeholder="请输入公告报纸名称"></a-input>
                </a-form-item>
                <a-form-item label="清税情况" name="etpsRepeal_payTax" v-if="formState.main_type != 2">
                    <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                        v-model:value="formState.etpsRepeal_payTax" placeholder="请选择">
                        <a-select-option value="1">已经清理完毕</a-select-option>
                        <a-select-option value="2">未涉及纳税义务</a-select-option>
                    </a-select>
                </a-form-item>
                <!-- 文件信息 -->
                <a-form-item name="tax_authority_clear_proof" label="清税证明照片" htmlFor="{null}" style="height: 110px">
                    <Upload :upload_path="formState.upload_path" :accept="['jpg', 'gif', 'png', 'jpeg']"
                        uploadType="picture-card" :limitation="99" v-model:value="formState.tax_authority_clear_proof"
                        uploadText="清税证明照片" :beforeCheck="beforeCheck">
                    </Upload>
                </a-form-item>
                <a-form-item label="清税证明文号" name="clearTaxFileNo"
                    v-if="formState.isTaxReg == 1 && formState.main_type == 2" required>
                    <a-input v-model:value="formState.clearTaxFileNo" placeholder="请输入清税证明文号"></a-input>
                </a-form-item>
                <a-form-item label="主管税务机关" name="taxRegOrgan"
                    v-if="formState.isTaxReg == 1 && formState.main_type == 2" required>
                    <a-input v-model:value="formState.taxRegOrgan" placeholder="请输入主管税务机关"></a-input>
                </a-form-item>

                <a-form-item name="investor_letter" htmlFor="{null}" label="全体投资人承诺书" v-if="formState.main_type != 2">
                    <Upload :upload_path="formState.upload_path" :accept="['jpg']" uploadType="picture-card"
                        :limitation="99" v-model:value="formState.investor_letter" uploadText="全体投资人承诺书"
                        :beforeCheck="beforeCheck" :size="1">
                    </Upload>
                </a-form-item>
                <a-form-item name="decree_dissolution" htmlFor="{null}" label="人民法院的破产裁定、解散裁判文书，行政机关责令关闭或者公司被撤销的文件"
                    v-if="formState.main_type != 2">
                    <Upload :upload_path="formState.upload_path" :accept="['jpg', 'gif', 'png', 'jpeg']"
                        uploadType="picture-card" :limitation="99" v-model:value="formState.decree_dissolution"
                        uploadText="其它文件" :beforeCheck="beforeCheck">
                    </Upload>
                </a-form-item>
                <!-- 经营者身份证正反面 -->
                <a-form-item name="fr_back" label="经营者身份证照片" htmlFor="{null}" v-if="formState.main_type == 2">
                    <a-row>
                        <a-col :span="12">
                            <IdCardForm v-model:front="formState.fr_front" v-model:back="formState.fr_back"
                                @change="frChange" :uploadPath="formState.upload_path"></IdCardForm>
                        </a-col>
                        <a-col :span="12">姓名: {{ formState.fr_name }}<br />身份证: {{ formState.fr_number }} </a-col>
                    </a-row>
                </a-form-item>

                <a-form-item name="dbtype" label="是否委托代办">
                    <a-radio-group v-model:value="formState.dbtype" button-style="solid" @change="quxiaoLly">
                        <a-radio-button :value="1">是</a-radio-button>
                        <a-radio-button :value="2">否</a-radio-button>
                    </a-radio-group>
                </a-form-item>
                <div v-if="formState.dbtype == 1">
                    <a-form-item label="代办人身份证正反面照片" name="identity_img_z" :required="formState.dbtype == 1"
                        :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }">
                        <a-row>
                            <a-col :span="8">
                                <IdCardForm v-model:front="formState.identity_img_z"
                                    v-model:back="formState.identity_img_f" @change="dbChange"
                                    :uploadPath="formState.upload_path"></IdCardForm>
                            </a-col>
                            <a-col :span="16"><a-row><a-col :span="10">
                                        <a-form-item label="姓名" name="agent_idcard_name"
                                            :required="formState.dbtype == 1" :labelCol="{ span: 9 }"
                                            :wrapperCol="{ span: 13 }">
                                            <a-input v-model:value="formState.agent_idcard_name"
                                                placeholder="身份证姓名"></a-input>
                                        </a-form-item> </a-col><a-col :span="14">
                                        <a-col><a-form-item label="电话" name="agent_tel"
                                                :required="formState.dbtype == 1" :labelCol="{ span: 6 }"
                                                :wrapperCol="{ span: 13 }">
                                                <a-input v-model:value="formState.agent_tel"
                                                    placeholder="代办人联系电话"></a-input>
                                            </a-form-item></a-col></a-col> </a-row><a-row>
                                    <a-col :span="24"><a-form-item label="身份证证件号码" name="agent_idcard_num"
                                            :required="formState.dbtype == 1" :labelCol="{ span: 7 }"
                                            :wrapperCol="{ span: 14 }">
                                            <a-input v-model:value="formState.agent_idcard_num"
                                                placeholder="身份证证件号码"></a-input>
                                        </a-form-item></a-col></a-row>
                            </a-col>
                        </a-row>
                    </a-form-item>
                </div>

                <a-form-item label="我的销售价" name="sales_price" required>
                    <a-input class="mr-2x" type="number" addon-after="元" v-model:value="formState.sales_price"
                        style="width: 200px" placeholder="请输入我的销售价"> </a-input>
                </a-form-item>
                <a-form-item label="我的拿货价">
                    <div class="red" style="font-size: 20px">
                        ￥<span>{{ state.purchase_price }}</span> 元
                    </div>
                </a-form-item>
                <a-form-item label="来源手机号" name="lianxi_mobile" required>
                    <a-input v-model:value="formState.lianxi_mobile" placeholder="请输入来源手机号" @change="
                        (v) => {
                            phoneChange(v, 'lianxi_mobile')
                        }
                    "></a-input>
                </a-form-item>

                <a-form-item label="代理商" name="sellerid" required>
                    <UserPick v-model:value="formState.sellerid" :disabled="user.id != 1" placeholder="代理商姓名或手机号码">
                    </UserPick>
                </a-form-item>
                <a-form-item label="此单备注（帮助记忆）" name="lianxi_name">
                    <a-textarea v-model:value="formState.lianxi_name" placeholder="" />
                </a-form-item>
            </a-form>
        </a-spin>
        <!-- 公司添加人员 -->
    </a-modal>
</template>

<script lang="ts" setup>
import baseService from '@/utils/http/axios'
import Upload from '@/components/base/Upload.vue'
import { reactive, onMounted, nextTick, h, ref, onBeforeUnmount, watch, computed } from 'vue'
import { message, Modal } from 'ant-design-vue'
import type { Rule } from 'ant-design-vue/es/form'
import dayjs from 'dayjs'
import AddressCascader from '@/components/base/AddressCascader.vue'
import { mobileRequiredValidator, mobileValidator } from '@/utils/util'
import IdCardForm from './components/IdCardForm.vue'
import UserPick from '@/components/base/UserPick.vue'
import ls from '@/utils/Storage'
const UserInfo = ls.get('USER_INFO')
const emit = defineEmits(['ok', 'cancel'])
import { useStore } from 'vuex'
const user = ls.get('USER_INFO')
import { debounce } from 'lodash-es'
const $store = useStore()
const formRef = ref()
const principalName = ref()
// 防抖器
let timer: any = null
const formLayout = {
    labelCol: {
        xs: { span: 7 },
        sm: { span: 7 }
    },
    wrapperCol: {
        xs: { span: 10 },
        sm: { span: 10 }
    }
}
// 定时器
let interval
onBeforeUnmount(() => {
    clearInterval(interval)
})
//规则
const etpsRepeal_rplReasonGb = (rule, value) => {
    if (!value) {
        return Promise.reject('请选择注销原因')
    }
    return Promise.resolve()
}
// const memo = (rule, value) => {
//   if (formState.main_type == 2) {
//     if (!value) {
//       return Promise.reject('请输入注销备注')
//     }
//   }
//   return Promise.resolve()
// }
const clearTaxFileNo = (rule, value) => {
    if (formState.main_type == 2 && formState.isTaxReg == 1) {
        if (!value) {
            return Promise.reject('请输入清税证明文号')
        }
    }
    return Promise.resolve()
}
const taxRegOrgan = (rule, value) => {
    if (formState.main_type == 2 && formState.isTaxReg == 1) {
        if (!value) {
            return Promise.reject('请输入主管税务机关')
        }
    }
    return Promise.resolve()
}
const etpsRepeal_announcePaper = (rule, value) => {
    if (formState.main_type != 2) {
        if (!value) {
            return Promise.reject('请输入公告报纸名称')
        }
    }
    return Promise.resolve()
}
const rules: Record<string, Rule[]> = {
    platform_id: [{ required: true, message: '选择平台' }],

    full_name: [{ required: true, message: '请输入主体名称' }],
    social_credit_code: [{ required: true, message: '请输入社会信用代码' }],
    liaison_identity: [{ required: true, message: '请输入联络员身份证号码' }],

    // agent_tel: [{ required: true, validator: mobileValidator }],
    identity_img_z: [{ message: '请输入身份证正面' }],
    identity_img_f: [{ message: '请输入身份证反面' }],
    recipient_area_ids: [{ message: '请填写省市区', trigger: 'change' }],
    appFlog_sumType: [{ required: true, message: '请选择营业执照提交方式' }],

    etpsRepeal_rplReasonGb: [{ validator: etpsRepeal_rplReasonGb }],
    //   memo: [{ validator: memo }],
    clearTaxFileNo: [{ validator: clearTaxFileNo }],
    taxRegOrgan: [{ validator: taxRegOrgan }],

    etpsRepeal_announcePaper: [{ validator: etpsRepeal_announcePaper }],
    fr_front: [{ required: true, message: '请输入经营者身份证正面照片' }],
    fr_back: [{ required: true, message: '请输入经营者身份证反面照片' }],
    lianxi_mobile: [{ required: true, validator: mobileRequiredValidator }]
}
const yyzzliandong = () => {
    if (formState.appFlog_sumType == 3) {
        //全国企业网遗失公示截图
        state.isRequired = false
    } else {
        //营业执照正本和副本2024-08-27改成非必填
        state.isRequired = false
    }
}
interface formState {
    logout_type: number | undefined //注销类型 1简易注销  2一般注销
    main_type: number | undefined //主体类型：1、公司，2、个体，3、个人独资企业，4合伙企业
    logout_sqtype: number | undefined //主体类型：1、收验证码2扫码
    main_type_name: string | undefined //主体类型中文
    recipient_area_ids: string | undefined //主体类型中文
    loading: boolean
    full_name: string | undefined //公司名字
    social_credit_code: string | null //统一社会信用代码
    liaison_identity: string | null //联络员身份证号码
    agent_idcard_name?: string | null //代办人名字
    agent_idcard_num?: string | null //代办人身份证号码
    agent_tel?: string | null //代办人手机号

    identity_img_z: string | undefined //身份证图片正面
    identity_img_f: string | undefined

    appFlog_sumType: number | undefined //原营业执照提交方式 1到登记窗口提交,3执照遗失或损坏公告作废
    etpsRepeal_rplReasonGb: string | undefined //注销原因
    isTaxReg: number | null //是否已办理涉税事项 1是 2否
    clearTaxFileNo: string | undefined //清税证明文号
    taxRegOrgan: string | null //主管税务机关
    memo: string | undefined //注销备注

    etpsRepeal_announcePaper: string | undefined //公告报纸名称
    etpsRepeal_payTax: string | undefined //清税情况
    investor_letter: object[] | undefined
    decree_dissolution: object[] | undefined

    proprietor_identity_copy: object[] | undefined //经营者身份证复印件
    fr_front: string | undefined //经营者身份证正面
    fr_back: string | undefined //经营者身份证反面
    fr_name: string | undefined //经营者姓名
    fr_number: string | undefined //经营者身份证号码
    upload_path: string | undefined //上传路径

    business_license_and_copy: object[] | undefined //营业执照正本和副本
    tax_authority_clear_proof: object[] | undefined //税务机关出具的清税证明
    dbtype: number

    lianxi_name: string | undefined //联系人
    lianxi_mobile: string | undefined //手机号
    sales_price: number | null //销售价
    sellerid: number | undefined //销售人
}
let formState = reactive<formState>({
    loading: false,
    logout_type: 1,
    main_type: 2,
    recipient_area_ids: '',
    logout_sqtype: 2,
    main_type_name: '个体户',
    full_name: '',
    social_credit_code: null,
    liaison_identity: null,
    agent_idcard_name: null,
    agent_idcard_num: null,
    agent_tel: null,

    //identity:'',
    identity_img_z: '',
    identity_img_f: '',

    appFlog_sumType: 3,
    etpsRepeal_rplReasonGb: '停止经营',
    isTaxReg: 0,
    clearTaxFileNo: '',
    taxRegOrgan: null,
    memo: '',

    etpsRepeal_announcePaper: '国家企业信用信息公示系统',
    etpsRepeal_payTax: '2',
    investor_letter: [],
    decree_dissolution: [],

    proprietor_identity_copy: [],
    fr_front: '',
    fr_back: '',
    fr_name: '',
    fr_number: '',
    upload_path: '',
    business_license_and_copy: [],
    tax_authority_clear_proof: [],
    dbtype: 1,
    lianxi_name: '',
    lianxi_mobile: '',
    sales_price: null,
    sellerid: 0
})
const props = defineProps({
    open: {
        type: Boolean
    },
    tableColumnsData: {
        type: Object,
        default: () => null
    }
})

onMounted(() => {
    // 初始化
    if (props.tableColumnsData?.id) {
        state.modalTitle = '编辑注销客户'
        state.loading = true
        state.isEdit = true
        state.isRequired = true
        queryDetail()
    } else {
        //添加注销客户，默认需要传营业执照正副本，默认是公司
        state.isRequired = true
        formState.sellerid = UserInfo.id
    }
    initCreated()
})

interface state {
    loading: boolean
    maskClosable: boolean //点击蒙层是否允许关闭
    modalTitle: string
    isEdit: boolean
    confirmLoading: boolean
    isRequired: boolean //business_license_and_copy 判断是否必填
    copyAuthorizationInfo: string
    curentPlatform: any
    purchase_price: number | null
}
const state = reactive<state>({
    //代办人搜索选择
    loading: false,
    maskClosable: false,
    modalTitle: '新增注销客户',
    // 是否为编辑
    isEdit: false,
    confirmLoading: false,
    isRequired: false,
    copyAuthorizationInfo: '',
    curentPlatform: {},
    purchase_price: null
})
const queryDetail = () => {
    let requestParam = {
        url: `/admin/v1/simpleLogout/${props.tableColumnsData?.id}/edit`,
        method: 'get'
    }
    baseService(requestParam)
        .then((res) => {
            state.loading = false
            Object.assign(formState, res.data)
            //改变是否传营业执照
            yyzzliandong()
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
            state.loading = false
        })
}
//省市区变动时去搜索代办人
const recipient_area_ids_change = (e, val) => {
    // formState.recipient_area_ids = e
    // //如果选择了省市区，则清空代办人信息
    // formState.agent_idcard_name = ''
    // formState.agent_tel = ''
    // formState.identity_img_z = ''
    // formState.identity_img_f = ''
    // formState.agent_idcard_num = ''
    // // 发送请求获取数据
    // let area_ids = formState.recipient_area_ids
    // let requestParam = {
    //     url: '/admin/v1/filings/checkWaiqin',
    //     data: { area_ids: area_ids },
    //     method: 'post'
    // }
    // baseService(requestParam)
    //     .then((res) => {
    //         if (res.data.length > 0) {
    //             //如果有指定的业务员,取一个
    //             let item = res.data[0]
    //             formState.agent_idcard_name = item.customer_name
    //             formState.agent_tel = item.customer_tel
    //             formState.identity_img_z = item.identity_card_front
    //             formState.identity_img_f = item.identity_card_contrary
    //             formState.agent_idcard_num = item.identity_card_number
    //         }
    //     })
    //     .catch((res) => {
    //         if (res.msg) {
    //             message.error(res.msg)
    //         } else {
    //             message.error('查询区域代办人失败')
    //         }
    //     })
}
//是否委托代办选否取消联络员
const quxiaoLly = () => {
    if (formState.dbtype == 2) {
        formState.agent_idcard_name = ''
        formState.agent_tel = ''
        formState.identity_img_z = ''
        formState.identity_img_f = ''
        formState.agent_idcard_num = ''
    }
}

// 切换公司主体类型
const principalTypeChange = (val) => {
    //处理名称
    if (val.target.value == 1) {
        formState.main_type_name = '公司'
        formState.etpsRepeal_rplReasonGb = '决议解散' //注销原因
    } else if (val.target.value == 2) {
        formState.main_type_name = '个体户'
        formState.etpsRepeal_rplReasonGb = '停止经营'
    } else if (val.target.value == 3) {
        formState.main_type_name = '个独'
        formState.etpsRepeal_rplReasonGb = '决议解散' //注销原因
    } else if (val.target.value == 4) {
        formState.main_type_name = '合伙'
        formState.etpsRepeal_rplReasonGb = '决议解散' //注销原因
    }
    //公司只能选代办
    formState.dbtype = 1
    uploadPathChange()
    calcPrice()
}

// 关闭
const cancelClick = (val) => {
    if (state.isEdit) {
        emit('cancel')
        return
    }
    emit('cancel')
}
// 提交
const onFormSubmit = () => {
    formRef.value
        .validate()
        .then(() => {
            formState.loading = true
            if (props.tableColumnsData?.id) {
                let requeryParam = {
                    url: '/admin/v1/simpleLogout/' + props.tableColumnsData.id,
                    method: 'put',
                    data: formState
                }
                baseService(requeryParam)
                    .then((res: any) => {
                        message.success(res.msg)
                        state.confirmLoading = false
                        formState.loading = false
                        emit('ok', 'edit', props.tableColumnsData.id)
                    })
                    .catch((res) => {
                        if (res) {
                            state.confirmLoading = false
                            formState.loading = false
                            if (res.msg) {
                                message.warning(res.msg)
                                return
                            }
                            message.warning('参数错误,请检查')
                        }
                    })
            } else {
                let requeryParam = {
                    url: '/admin/v1/simpleLogout',
                    method: 'post',
                    data: formState
                }
                baseService(requeryParam)
                    .then((res: any) => {
                        message.success(res.msg)
                        formState.loading = false
                        state.confirmLoading = false
                        emit('ok', 'add', res.data)
                    })
                    .catch((res) => {
                        formState.loading = false
                        state.confirmLoading = false
                        if (res) {
                            state.confirmLoading = false
                            if (res.msg) {
                                message.warning(res.msg)
                                return
                            }
                            message.warning('参数错误,请检查')
                        }
                    })
            }
        })
        .catch((val) => {
            state.loading = false
            message.warning('请检查必填项')
        })
}
//点击复制授权方式
const copyShouquan = () => {
    var input = document.createElement('textarea')
    //将input的值设置为需要复制的内容
    input.value = state.copyAuthorizationInfo
    //添加input标签
    document.body.appendChild(input)
    //选中input标签
    input.select()
    //执行复制
    document.execCommand('copy')
    //成功提示信息
    message.success('复制成功！')
    //移除input标签
    document.body.removeChild(input)
}
const initCreated = () => {
    let requestParam = {
        url: '/admin/v1/calcel/create',
        method: 'post',
        data: {}
    }
    baseService(requestParam)
        .then((res: any) => {
            state.copyAuthorizationInfo = `用法人手机微信搜索“电子营业执照”，点击【下载电子营业执照】-输入信息-完成人脸识别-点击湖南-点击店子名称-返回主页-点击【授权他人管理营业执照】-点击店名-输入营业执照密码123456-【添加证照管理员】-输入${res.data.idcard_name}的信息-确认选择。
${res.data.idcard_name}的信息：
${res.data.idcard_name}${res.data.idcard_num}
手机号码随便填`
            state.curentPlatform = res.data.platform
            calcPrice()
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('复制失败')
            }
        })
        .finally(() => {
            state.loading = false
        })
}
//改变名称修改上传路径
const uploadPathChange = () => {
    if (!state.isEdit) {
        formState.upload_path = `public/uploads/注销/湖南省/客户资料/${formState.main_type_name}/${dayjs().format('YYYYMMDD')}/${formState.full_name}/`
    }
}
//法人上传
const frChange = (info) => {
    formState.fr_name = info.name
    formState.fr_number = info.id_card_number
    //复制到代办人栏目,如果代办人未空或同上
    if ((!formState.identity_img_z || formState.identity_img_z == info.id_card_front) && (!formState.identity_img_f || formState.identity_img_f == info.id_card_back)) {
        formState.identity_img_z = info.id_card_front
        formState.identity_img_f = info.id_card_back
        formState.agent_idcard_name = info.name
        formState.agent_idcard_num = info.id_card_number
    }
}
const dbChange = (info) => {
    formState.agent_idcard_name = info.name
    formState.agent_idcard_num = info.id_card_number
}
// 上传图片之前检查
const beforeCheck = () => {
    if (formState.full_name == '') {
        message.warning('请先输入主体名称')
        return false
    }
    return true
}
const calcPrice = () => {
    if (state.curentPlatform) {
        if (formState.main_type == 2) {
            if (!state.isEdit) {
                formState.sales_price = state.curentPlatform.gt_guide_price
            }
            state.purchase_price = state.curentPlatform.gt_price
        } else {
            if (!state.isEdit) {
                formState.sales_price = state.curentPlatform.ngt_guide_price
            }
            state.purchase_price = state.curentPlatform.ngt_price
        }
    }
}
const phoneChange = (v, type) => {
    let str = v.target.value.replaceAll(/\D/g, '')
    formState[type] = str
}
const aicheck = () => {
    if (formState.full_name.indexOf('公司') > -1) {
        formState.main_type = 1
    } else if (formState.full_name.indexOf('个体工商户') > -1) {
        formState.main_type = 2
    } else if (formState.full_name.indexOf('个人独资') > -1) {
        formState.main_type = 3
    } else if (formState.full_name.indexOf('合伙') > -1) {
        formState.main_type = 4
    }
    principalTypeChange({ target: { value: formState.main_type } })
}
</script>

<style lang="less" scoped>
.category {
    padding: 30px 0;
    display: flex;
    justify-content: space-around;

    :deep(.ant-input-number-handler-wrap) {
        display: none;
    }

    .category-item {
        font-size: 24px;
        cursor: pointer;
        padding: 50px;
        border-radius: 15px;
        width: 100%;
        margin-right: 20px;
        text-align: center;
    }

    .company {
        border: 1px solid #e0f9f2;
        background: #e0f9f2;
        color: #00d097;
    }

    .company.check {
        border: 1px solid #00d097;
    }

    .individual {
        background: #e8f1ff;
        color: #3f8cff;
        border: 1px solid #e8f1ff;
    }

    .individual.check {
        border: 1px solid #3f8cff;
    }

    .proprietorship {
        border: 1px solid #e6fffb;
        background: #e6fffb;
        color: #13c2c2;
    }

    .proprietorship.check {
        border: 1px solid #13c2c2;
    }
}

.platform-label {
    line-height: 32px;
    max-width: 102px;
    display: flex;
    justify-content: end;
}

.platform {
    :deep(.ant-form-item-label) {
        display: none;
    }

    :deep(.ant-form-item .ant-form-item-label > label.ant-form-item-no-colon::after) {
        display: none;
    }
}

.ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
}

.add-button {
    position: absolute;
    right: 70px;
    top: 10px;
}

.positionItem {
    display: inline-block;
    margin: 5px 0;
}

// 通过标签样式
.range {
    display: inline-block;
    box-sizing: border-box;
    height: auto;
    margin-right: 8px;
    margin-bottom: 4px;
    padding: 4px 7px;
    font-size: 12px;
    font-variant: tabular-nums;
    line-height: 20px;
    white-space: inherit;
    list-style: none;
    border-radius: 2px;
}

.pass-through {
    color: #5ca200 !important;
    background: #f6ffe4 !important;
    border: 1px solid #bad092 !important;
}

.no-pass {
    color: #ff6e03 !important;
    background: #fff5e7 !important;
    border: 1px solid #ffc067 !important;
}

:deep(.ant-modal-title) {
    font-size: 20px;
}

.share-ownership {
    min-width: 1100px;
    margin-top: 50px;
    position: relative;
    display: flex;
    justify-content: center;

    .ownership-table {
        margin-bottom: 30px;
        width: 90%;
    }
}

:deep(.ant-form-item-label) {
    display: flex;
    justify-content: flex-end;
    line-height: 16px;
    height: 40px;
    align-items: center;

    label {
        white-space: normal;
        text-align: right;
        padding-right: 10px;
    }
}
</style>
